import Vue from 'vue'
import router from './config/router.js'
import store from './config/store.js'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import '@/css/main.min.css'
import 'bootstrap'


Vue.use(require('vue-moment'));

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

Vue.use(BootstrapVue)
Vue.config.productionTip = false

import apiHandlerMi from '@/mixins/apiHandlerMI.js';
import globalMi from '@/mixins/globalMI.js';
Vue.mixin(apiHandlerMi)
Vue.mixin(globalMi)
Vue.use(require('vue-moment'));

import axios from 'axios'

//axios
Vue.prototype.$axios = axios

// new Vue({
//   store,
//   render: h => h(App),
// }).$mount('#app')

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')